<template>
    <!-- Create New Bet -->
    <div class="modal fade" id="createNewBet" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header pb-1">
                    <h5 class="modal-title font-weight-bold">{{ __('bets.New Bet') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body py-0">

                    <!-- Form -->
                    <form @submit.prevent="saveAndClose" novalidate="true">

                        <!-- Event -->
                        <div class="form-group">
                            <label class="">{{ __('bets.Event') }} *</label>

                            <v-select
                                taggable
                                :class="{ 'is-invalid': form.errors.has('fk_event') }"
                                v-model="event"
                                :filterable="false"
                                :options="events"
                                @search="onSearchPartnerEvent"
                                :create-option="event => ({ createEvent: true, name: event })"
                                label="name">

                                <template #selected-option="{ name, sport, date }">
                                    <div style="display: flex; align-items: baseline;">
                                        <strong>{{ name }}</strong>
                                        <em class="text-muted ml-1" v-if="sport || date"> - {{ sport }} - {{ date | moment("dddd, MMMM DD YYYY") }} | {{ date | moment("from") }}</em>
                                    </div>
                                </template>

                                <template #option="{ name, sport, date }">
                                    <h6 style="margin: 0">{{ name }}</h6>
                                    <em class="text-muted" v-if="sport || date">{{ sport }} - {{ date | moment("dddd, MMMM DD YYYY") }} - {{ date | moment("from") }}</em>
                                </template>

                            </v-select>

                            <has-error :form="form" field="fk_event"></has-error>
                        </div>

                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Date -->
                                <div class="form-group">
                                    <label>{{ __('bets.Date') }} *</label>

                                    <b-form-datepicker
                                        v-model="form.date"
                                        :class="{ 'is-invalid': form.errors.has('date') }"
                                        :locale="locale"
                                        placeholder=""
                                        :disabled="disabled">
                                        </b-form-datepicker>

                                    <has-error :form="form" field="date"></has-error>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Sport -->
                                <div class="form-group">
                                    <label class="">{{ __('bets.Sport') }} *</label>

                                    <v-select
                                        :class="{ 'is-invalid': form.errors.has('fk_sport') }"
                                        :disabled="disabled"
                                        v-model="form.fk_sport"
                                        :options="sports"
                                        :reduce="sport => sport.id"
                                        label="name">
                                    </v-select>

                                    <has-error :form="form" field="fk_sport"></has-error>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-6">
                                <!-- Competitions -->
                                <div class="form-group">
                                    <label class="">{{ __('bets.Competition') }} *</label>

                                    <v-select
                                        :class="{ 'is-invalid': form.errors.has('fk_competition') }"
                                        :disabled="disabled"
                                        v-model="form.fk_competition"
                                        :options="competitions"
                                        :selectable="option => option.type == 'item'"
                                        :reduce="competition => competition.id"
                                        label="name">

                                        <template #option="{ type, name }">

                                            <span v-if="type == 'group'" class="font-weight-bold text-secondary">
                                                {{ name }}
                                            </span>

                                            <span v-if="type == 'item'" class="">
                                                {{ name }}
                                            </span>

                                        </template>

                                    </v-select>

                                    <has-error :form="form" field="fk_competition"></has-error>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <!-- Market / Strategies -->
                                <div class="form-group">
                                    <label class="">{{ __('bets.Market / Strategy') }} *</label>

                                    <v-select
                                        :class="{ 'is-invalid': form.errors.has('fk_market') }"
                                        v-model="form.fk_market"
                                        :options="markets"
                                        :selectable="option => option.type == 'item'"
                                        :reduce="market => market.id"
                                        label="name">

                                        <template #option="{ type, name }">

                                            <span v-if="type == 'group'" class="font-weight-bold text-secondary">
                                                {{ name }}
                                            </span>

                                            <span v-if="type == 'item'" class="">
                                                {{ name }}
                                            </span>

                                        </template>

                                    </v-select>

                                    <has-error :form="form" field="fk_market"></has-error>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-4">
                                <!-- Stake -->
                                <div class="form-group">
                                    <label class="">{{ __('bets.Stake') }} *</label>

                                    <currency-input
                                        :class="{ 'is-invalid': form.errors.has('stake') }"
                                        :locale="locale"
                                        :currency='currency'
                                        class="form-control font-weight-bold"
                                        v-model="form.stake"
                                    />

                                    <has-error :form="form" field="stake"></has-error>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <!-- Stake -->
                                <div class="form-group">
                                    <label class="">{{ __('bets.Result') }} *</label>

                                    <currency-input
                                        :locale="locale"
                                        :currency='currency'
                                        class="form-control font-weight-bold"
                                        v-bind:class="{'is-invalid': form.errors.has('result'), 'text-muted': form.result == 0, 'text-success': form.result > 0, 'text-danger': form.result < 0}"
                                        v-model="form.result"
                                    />

                                    <has-error :form="form" field="result"></has-error>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <!-- Odd -->
                                <div class="form-group">
                                    <label class="">{{ __('bets.Odd') }}</label>

                                    <input type="number" class="form-control" v-model="form.odd" :class="{ 'is-invalid': form.errors.has('odd') }" />

                                    <has-error :form="form" field="odd"></has-error>
                                </div>
                            </div>
                        </div>

                        <!-- Description -->
                        <div class="form-group mb-0">
                            <label class="">{{ __('bets.Description') }}</label>

                            <textarea class="form-control" v-model="form.description" :class="{ 'is-invalid': form.errors.has('description') }">
                            </textarea>

                            <div class="text-right small mt-2">
                                {{ 600 - form.description.length > 0 ? 600 - form.description.length : 0 }} {{ __('bets.characters left') }}
                            </div>

                            <has-error :form="form" field="description"></has-error>
                        </div>

                        <!-- Tags -->
                        <div class="form-group">
                            <label class="">{{ __('bets.Tags') }}</label>

                            <v-select
                                taggable
                                multiple
                                push-tags
                                :class="{ 'is-invalid': form.errors.has('tag') }"
                                v-model="form.tags"
                                label="name">

                            </v-select>

                            <has-error :form="form" field="tags"></has-error>
                        </div>

                        <!-- Pending -->
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" v-model="form.pending" id="defaultPending">
                                <label class="custom-control-label" for="defaultPending">
                                    {{ __('bets.Save as a Pending Bet') }}
                                </label>
                            </div>
                        </div>

                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">{{ __('bets.Close') }}</button>

                    <button type="button" class="btn btn-primary" @click="saveAndClose" :disabled="form.busy">
                        <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="form.busy"></span>
                        <span v-if="!form.busy">{{ __('bets.Save') }}</span>
                        <span v-if="form.busy">{{ __('bets.Saving') }} ...</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Form } from 'vform'

export default {
    props: ['locale', 'currency', 'endpointCreate'],
    data() {
        return {
            disabled: false,
            event: null,
            form: new Form({
                fk_event: null,
                fk_sport: null,
                date: null,
                fk_competition: null,
                fk_market: null,
                stake: null,
                result: null,
                odd: null,
                description: '',
                tags: [],
                pending: false
            }),
            events: [],
            sports: [],
            competitions: [],
            markets: [],
        }
    },
    created() {
        // Load Sports
        this.listAllSports();
    },
    watch: {
        'event': function (event) {
            if (event) {

                if (event.id) {
                    // Exist Event
                    this.form.fk_event = event.name;
                    this.form.fk_sport = event.fk_sport;
                    this.form.date = event.date

                    if (event.competition) {
                        this.form.fk_competition = 'competition_' + event.competition;

                        this.disabled = true;
                    }

                } else if (event.createEvent) {

                    // Create New Event
                    this.form.fk_event = event.name;
                    this.form.fk_sport = null;
                    this.form.fk_competition = null;
                    this.form.date = this.$moment(new Date()).format('YYYY-MM-DD')

                    this.disabled = false;
                } else {

                    // Other
                    this.disabled = false;
                }
            } else {

                this.form.fk_event = null;

                // Other
                this.disabled = false;
            }
        },
        'form.fk_sport': function (fk_sport, oldValue) {
            if (fk_sport) {
                if (oldValue != null) {
                    this.form.fk_competition = null;
                    this.form.fk_market = null;
                }
                this.listAllCompetitionsFromSport(fk_sport)
                this.listAllMarketAndStrategiesFromSport(fk_sport)
            }
        },
    },
    methods: {

        // Save Form and Close
        saveAndClose() {
            this.form.post(this.endpointCreate)
                .then(result => {
                    if (result.redirect) {
                        window.location = result.redirect
                    }
                })
        },

        // Search Partner Event
        onSearchPartnerEvent(search, loading) {
            // Loading
            loading(true)

            // Force Check Last Search
            if (search == "") {
                if (this.event) {
                    search = this.event.name
                }
            }

            // Search
            this.onSearchPartnerEventDebounce(search, loading, this);
        },

        // Search Partner Event
        onSearchPartnerEventDebounce: _.debounce((search, loading, vm) => {
            axios.get(`/bets/search-partner-event?name=${search}`)
                .then(result => {
                    vm.events = result
                    loading(false);
                })
            },
            350
        ),

        // List All Sports
        listAllSports() {
            axios.get('/bets/sports')
                .then(result => {
                    this.sports = result
                })
        },

        // List All Competition From Sport
        listAllCompetitionsFromSport(fk_sport) {
            axios.get(`/bets/competitions/${fk_sport}`)
                .then(result => {
                    this.competitions = result
                })
        },

        // List All Market And Strategies From Sport
        listAllMarketAndStrategiesFromSport(fk_sport) {
            axios.get(`/bets/markets-and-strategies/${fk_sport}`)
                .then(result => {
                    this.markets = result
                })
        },
    }
}
</script>

<style>

</style>
